const moment = require('moment')

export default {
  namespaced: true,
  state: {
    day1: [
      {
        thumbnail: '/img/channel07/opening.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆<br>各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/chu.png',
        title: '＃リトルフォトコン',
        description: '「＃7月リトルフォトコン」をつけて投稿していただいたみなさんのお写真が紹介されるかも！<br>今月のテーマは「はじめての○○コンテスト」<br>この回では「はじめてのチュウ部門」に応募してくださったお写真をご紹介！<br>当日、グランプリも発表いたします！<br>見事グランプリに選ばれたら8月オンラインフェスタの広告モデルになれちゃう♡<br>素敵なお写真お待ちしています☆',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/bday.png',
        title: '7月生まれの誕生日お祝い会',
        description: '7月生まれのご家族がいるママたち集まれ～～～！<br>みんなで誕生日をお祝いしましょう♪同じ誕生日の人にも出会えるかも？！<br>お祝いだけじゃなく、お誕生日のプレゼント事情やご飯事情についてもコメントで盛り上がろう！<br>ご家族特有のお誕生日儀式をお持ちの方もコメントで教えてください☆',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/ending.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ],
    day2: [
      {
        thumbnail: '/img/channel07/opening.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/game.png',
        title: '東西対決！私はだれでしょうゲーム！',
        description: 'お題を知らないリトル・ママスタッフにNGワードを使わずにヒントを出して正解に導こう！<br>東日本ママチームと西日本ママチームに分かれて制限時間内により多く正解したチームの勝ち！<br>一致団結して対決だ！',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/aidoru.png',
        title: 'リトル・ママからアイドル誕生！？',
        description: 'ママが作るママのための男性アイドルグループオーディションを開催！<br>リトル・ママ史上初！歌って踊れるアイドルグループを作ります！<br>今回はオーディションの中身とママの参加方法をご紹介します♪<br>審査員は全国のママ達！一緒にアイドルグループのプロデュースをしませんか？<br>さらになんと当日は候補生たちも遊びに来ちゃうかも・・・！？<br>ぜひお見逃しなく！！',
        start: '13:00',
        end: '13:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/otetsudai.png',
        title: '＃リトルフォトコン',
        description: '「＃7月リトルフォトコン」をつけて投稿していただいたみなさんのお写真が紹介されるかも！<br>今月のテーマは「はじめての○○コンテスト」<br>この回では「はじめてのお手伝い部門」に応募してくださったお写真をご紹介！<br>当日、グランプリも発表いたします！<br>見事グランプリに選ばれたら8月オンラインフェスタの広告モデルになれちゃう♡<br>素敵なお写真お待ちしています☆',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel07/ending.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    onair: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-07-28', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBetween('2020-07-28 ' + program.start, '2020-07-28 ' + program.end, 'minute', '[]')
        })
      } else if (date.isSame('2020-07-29', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBetween('2020-07-29 ' + program.start, '2020-07-29 ' + program.end, 'minute', '[]')
        })
      }
      return programs[0]
    },
    next: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-07-28', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBefore('2020-07-28 ' + program.start)
        })
      } else if (date.isSame('2020-07-29', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBefore('2020-07-29 ' + program.start)
        })
      }
      return programs[0]
    }
  }
}
